import { render, staticRenderFns } from "./01-Start.vue?vue&type=template&id=50c6e925&scoped=true&"
import script from "./01-Start.vue?vue&type=script&lang=js&"
export * from "./01-Start.vue?vue&type=script&lang=js&"
import style0 from "./01-Start.vue?vue&type=style&index=0&id=50c6e925&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6e925",
  null
  
)

export default component.exports